export const initMailScenarioRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/mailscenario",
          name: "mailscenario",
          component: () => import("@/pages/manage/mailscenarios/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/mailscenario/:id",
          name: "mailscenario-id",
          component: () => import("@/pages/manage/mailscenarios/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
